import { render, staticRenderFns } from "./VerificationCode.vue?vue&type=template&id=0ec9b087&scoped=true"
import script from "./VerificationCode.vue?vue&type=script&lang=js"
export * from "./VerificationCode.vue?vue&type=script&lang=js"
import style0 from "./VerificationCode.vue?vue&type=style&index=0&id=0ec9b087&prod&scoped=true&lang=less"
import style1 from "./VerificationCode.vue?vue&type=style&index=1&id=0ec9b087&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec9b087",
  null
  
)

export default component.exports